<template>
  <div class="related-item" @click="routeToRecipe(categoryKey, recipeKey)" v-if="name && categoryKey && recipeKey">
    <img class="related-image" v-if="imageUrl" :src="imageUrl" :alt="name" />
    <div class="related-content">
      <h4>{{name}}</h4>
      <h5 v-if="categoryName">{{categoryName}}</h5>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: "RelatedItem",
    props: {
      categoryKey: String,
      recipeKey: String,
      name: String,
      imageUrl: {
        type: String,
        default: null
      },
    },
    computed: {
      ...mapState("category", ["categories"]),
      categoryName() {
        const cat = this.categories.find(cat => this.categoryKey === cat.key);
        return cat && cat.name;
      }
    },
    methods: {
      routeToRecipe(categoryKey, key) {
        this.$router.push({
          name: "RecipeView",
          params: { categoryKey, key }
        });
      }
    },
  };
</script>

<style scoped lang="scss">
  .related-item {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background: #191919;
    color: #aaa;
    position: relative;
    overflow: hidden;

    h4,
    h5 {
      font-size: 24px;
      text-transform: uppercase;
      margin: 0;
      font-weight: 600;
      text-shadow: 0 2px 8px rgba(0,0,0,0.3);
      color: #fff;
      transition: all 0.2s ease-in;
    }

    h5 {
      font-size: 16px;
      border: 0;
      color: #bbb;
      transition: all 0.2s ease-in;
    }

    .related-image {
      width: 100%;
      height: 100%;
      transform: scale(1.1);
      transition: all 0.2s ease-in;
      object-fit: cover;
      position: absolute;
      z-index: 1;
    }

    .related-content {
      position: relative;
      z-index: 2;
      background-image: linear-gradient(transparent, rgba(0,0,0,0.6) 50%);
      padding: 40px $gutter $gutter $gutter;
    }

    &:hover {
      cursor: pointer;

      h4 {
        text-shadow: 0 4px 12px rgba(0,0,0,0.4);
      }

      h5 {
        color: #fff;
      }

      .related-image {
        opacity: 0.8;
        transform: scale(1.2);
      }
    }
  }
</style>
